import React from "react";
import "./AdminFeedbackHeader.css";

const AdminFeedbackHeader = () => {
  return (
    <section className="UserFeedBackHeader-container">
      <div className="UserFeedBackHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="UserFeedBackHeader-title">Feedback Management</h1>
          <div className="UserFeedBackHeader-breadcrumb">
            <button
              className="btn"
              style={{ backgroundColor: "#04143B", color: "#fff" }}
            >
              Home - Feedback Management
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminFeedbackHeader;
